export class SaleBillModel {
    SrNo: number;
    BillNo: string;
    BillType: string;
    BillDate: string;
    CustomerName: string;
    ContactNumber: string;
    BalanceAmount: number;
    PaidAmount: number;
    TotalAmount: number;
    Remark: string;
    Deposit: string;
}